module.exports = __webpack_public_path__ + "static/img/line.a85329d2.png";